import { render, staticRenderFns } from "./PackagePayment.vue?vue&type=template&id=459703d1&scoped=true&"
import script from "./PackagePayment.vue?vue&type=script&lang=js&"
export * from "./PackagePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459703d1",
  null
  
)

export default component.exports